import type {SectionWeekId} from '@cip/core/section';
import type {FirestoreDataConverter} from 'firebase/firestore';
import {getUserDocumentRef} from './User';
import type {CourseId, UserId} from 'types/common';
import {doc} from 'firebase/firestore';
export interface UserAttendance {
  /**
   * The attendance of the user for each section week.
   */
  [sectionWeek: SectionWeekId]: boolean;
}

const userAttendanceConverter: FirestoreDataConverter<UserAttendance> = {
  toFirestore: attendance => attendance,
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    if (!data || typeof data !== 'object') {
      return {};
    }
    const attendance = data as UserAttendance;
    if (Object.keys(attendance).length === 0) {
      return {};
    }
    for (const [key, value] of Object.entries(attendance)) {
      try {
        const sectionWeek = Number(key) as SectionWeekId;
        attendance[sectionWeek] = value;
      } catch (error) {
        console.error(`Error converting attendance for key ${key}: ${error}`);
      }
    }
    return attendance;
  },
};
export const getUserAttendanceDocumentRef = (
  userId: UserId,
  courseId: CourseId,
) => {
  return doc(getUserDocumentRef(userId), courseId, 'sectionAttendance').withConverter(
    userAttendanceConverter,
  );
};
